module.exports = __webpack_public_path__ + "img/third@2x.6a030156.png";